import { Box, FluidImage, Spinner, Typography } from '@vp/swan';
import { __ } from '@99designs/i18n';

export function GenerateBriefLoadingPage() {
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            pt={'9'}
        >
            <FluidImage
                src={
                    'https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/expert_services/Brief/Intelligent%20Brief/loading.svg'
                }
                alt={__('Loading project brief')}
                style={{ maxHeight: '104px', maxWidth: '104px' }}
            />
            <Typography fontSkin={'body-standard-bold'} textAlign={'center'} pt={'4'}>
                {__('Customizing your project brief', {
                    _context:
                        'This is the title for the loading page when the custom brief form is being created',
                })}
            </Typography>
            <Typography
                fontSkin={'body-standard'}
                textColor={'subtle'}
                textAlign={'center'}
                pt={'3'}
            >
                {__('Please wait while we tailor the questions for your project.', {
                    _context:
                        'Info text on the loading page when the custom brief form is being created',
                })}
            </Typography>
            <Spinner size="super" accessibleText="Loading..." pt={'6'} />
        </Box>
    );
}
